import EditSubscriptionForm from 'src/components/Forms/EditSubscriptionForm';
import { MODALS } from 'src/models/ModalModel';
import ModalBase from 'src/components/Modals/ModalBase';
import { MODALS_SIZE } from 'src/models/modal';
import { FORM } from 'src/constants/Form';

const EditSubscriptionModal = () => (
  <ModalBase name={MODALS.editSubscription} size={MODALS_SIZE.medium} form={FORM.get_subscription}>
    <EditSubscriptionForm />
  </ModalBase>
);

export default EditSubscriptionModal;
